<template>
  <sui-page>
    <sui-page-header title="Optional Info"></sui-page-header>
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="btn_wrap">
          <div class="comm_infowrap">
            <p>신청권한 신청상태 및 보유권한에 관한 조회만 가능합니다.</p>
          </div>
          <button type="button" class="comm_btn_Reset ">초기화</button>
          <button type="button" class="comm_btn_Scr">검색</button>
        </div>
      </div>
      <div class="comm_title_wrap">
        <span class="sui-input-label__star"></span>
        <h4>타이틀+인포메시지</h4>
          <div class="comm_line_div"/>
          <div class="comm_infowrap">
            <p>신청권한 신청상태 및 보유권한에 관한 조회만 가능합니다.</p>
          </div>
      </div>
      <div class="comm_infowrap">
        <p>신청권한 신청상태 및 보유권한에 관한 조회만 가능합니다.</p>
      </div>
      <pre>
       <code>
         &lt;div class="comm_title_wrap"&gt;
           &lt;span class="sui-input-label__star"&gt;&lt;/span&gt;
           &lt;h4&gt;타이틀+인포메시지&lt;/h4&gt;
             &lt;div class="comm_line_div"/&gt;
             &lt;div class="comm_infowrap"&gt;
               &lt;p&gt;신청권한 신청상태 및 보유권한에 관한 조회만 가능합니다.&lt;/p&gt;
             &lt;/div&gt;
         &lt;/div&gt;
         &lt;div class="comm_infowrap"&gt;
           &lt;p&gt;신청권한 신청상태 및 보유권한에 관한 조회만 가능합니다.&lt;/p&gt;
         &lt;/div&gt;
      </code>
    </pre>
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <span class="sui-input-label__star"></span>
        <h4>타이틀+경고메시지</h4>
        <div class="btn_wrap">
          <div class="info caution">검색되지 않을 경우 DB에 메뉴를 등록하시기 바랍니다.</div>
        </div>
      </div>
      <pre>
         <code>
         &lt;div class="comm_title_wrap"&gt;
           &lt;span class="sui-input-label__star"&gt;&lt;/span&gt;&lt;h4&gt;타이틀+경고메시지&lt;/h4&gt;
           &lt;div class="info caution"&gt;검색되지 않을 경우 DB에 메뉴를 등록하시기 바랍니다.&lt;/div&gt;
         &lt;/div&gt;
      </code>
    </pre>
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <h4>타이틀+경고메시지</h4>
        <div class="comm_line_div"/>
        <div class="info caution">검색되지 않을 경우 DB에 메뉴를 등록하시기 바랍니다.</div>
      </div>
      <pre>
         <code>
           &lt;div class="comm_title_wrap"&gt;
             &lt;h4&gt;타이틀+경고메시지&lt;/h4&gt;
                &lt;div class="comm_line_div"/&gt;
             &lt;div class="info caution"&gt;검색되지 않을 경우 DB에 메뉴를 등록하시기 바랍니다.&lt;/div&gt;
           &lt;/div&gt;
      </code>
    </pre>
    <div class="mrB50"></div>
    <div class="comm_info_wrap1st">
      <p>사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)</p>
    </div>
      <div class="mrB20"></div>
    <div class="comm_info_wrap1st">
      <p>사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
        (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
        (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
        (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
        (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.</p>
    </div>
    <pre>
       <code>
         &lt;div class="comm_info_wrap1st"&gt;
           &lt;p&gt;사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.&lt;/p&gt;
         &lt;/div&gt;
    </code>
    </pre>
    <div class="mrB50"></div>
    <div class="comm_info_wrap2nd">
      <p>사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)</p>
    </div>
      <div class="mrB20"></div>
    <div class="comm_info_wrap2nd">
      <p>사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)</p>
    </div>
    <pre>
       <code>
         &lt;div class="comm_info_wrap2nd"&gt;
           &lt;p&gt;사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.&lt;/p&gt;
         &lt;/div&gt;
    </code>
    </pre>
    <div class="mrB50"></div>
    <div class="comm_info_wrap3rd">
      <p>사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)</p>
    </div>
      <div class="mrB20"></div>
    <div class="comm_info_wrap3rd">
      <p>사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다. (단, 메탄올은 세척용에 한함)</p>
    </div>
    <pre>
       <code>
         &lt;div class="comm_info_wrap3rd"&gt;
           &lt;p&gt;사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.
             (단, 메탄올은 세척용에 한함)사회적 이슈물질은 기흥/화성/평택 사업장 사용을 금지하고 있습니다.&lt;/p&gt;
         &lt;/div&gt;
    </code>
    </pre>

    </sui-page-contents>
  </sui-page>
</template>
<script>
  /*global http*/
  export default {
    name: 'comp_optionalInfo',
    data() {
      return {
      };
    },
    computed: {},
    watch: {},
    datasets: [],
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {},
  };
</script>
<style scoped>
  pre {
    background-color: #282C34;
    border: 1px solid #e4e4e4
  }
  code {
    font-family: AppleSDGothicNeo-Regular, "NanumGothic", dotum, "돋움체", sans-serif;
    font-size: 14px;
    color: #C8EBFA;
    line-height: 150%;
  }
</style>
